import * as _ from 'lodash';
import { Component, OnInit }  from '@angular/core';
import { Router }             from '@angular/router';

import { AdminService }   from '../services/admins/admin.service';
import { UsersComponent } from '../users/users.component';
import { PatientService } from '../services/patients/patient.service';
import { ProviderService } from '../services/providers/provider.service';
import { DateService } from '../services/date.service';
import { Auth } from '../services/auth.service';

enum gViewState {
  NORMAL,
  FAILED_VALIDATION,
  VALIDATING,
  DISCHARGED,
  ALL_VALIDATING,
  MY_DISCHARGE,
  ALL_DISCHARGED
}

@Component({
  moduleId: module.id,
  selector: 'patient-validation',
  templateUrl: 'patient-validation.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class PatientValidationComponent extends UsersComponent {

  constructor(
    protected router: Router,
    protected adminService: AdminService,
    protected patientService: PatientService,
    protected providerSevice: ProviderService,
    protected dateService: DateService,
    protected auth: Auth) { super(router, patientService, providerSevice); }

  ViewState = gViewState;
  dischargeViews = [ this.ViewState.DISCHARGED, this.ViewState.MY_DISCHARGE, this.ViewState.ALL_DISCHARGED];
  validationViews = [ this.ViewState.ALL_VALIDATING, this.ViewState.FAILED_VALIDATION, this.ViewState.VALIDATING, this.ViewState.NORMAL]

  private user : any = null;
  private viewState = this.ViewState.NORMAL;
  hasPatientValidationPermission:Boolean = false;

  protected getDetailUrl(): string {

    return '/patient/' + this.selectedUser.id;
  };

  protected getUserString(): string {

    return 'patientForValidation';
  };

  protected getUsersString(): string {

    return 'patientsForValidation';
  };

  createdAt(users: any[]) {
    for (let i = 0; i < users.length; i++) {
      users[i].createdAt = this.dateService.convertToLocalDateString(users[i].createdAt);
      users[i].dischargeDate = this.dateService.convertToLocalDateString(users[i].dischargeDate);
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.hasPatientValidationPermission = this.auth.hasPatientValidationPermission();
    this.adminService.getMe()
    .then(user => {
      this.user = user;
      this.getData();
    })
  }

  getData(): void {
    if (this.viewState == this.ViewState.FAILED_VALIDATION)
      this.getUsersWithFilter({validationInfo: true, needsValidation: false, failedValidation: true, sortDirection: 'desc' })
    else if (this.viewState == this.ViewState.NORMAL)
      this.getUsersWithFilter({validationInfo: true, needsValidation: true, validatorUser: true, sortDirection: 'asc' })
    else if (this.viewState == this.ViewState.VALIDATING)
    this.getUsersWithFilter({validationInfo: true, needsValidation: true, showValidating: true, sortDirection: 'asc' })
    else if (this.viewState == this.ViewState.ALL_VALIDATING)
    this.getUsersWithFilter({validationInfo: true, needsValidation: true,sortDirection: 'asc' })
    else if (this.viewState == this.ViewState.DISCHARGED)
      this.getUsersWithFilter({validationInfo: true, wasDischarged: true, needsAdministrativeDischarge: true, showDischargeAdmin: false,sortDirection: 'desc' })
    else if (this.viewState == this.ViewState.MY_DISCHARGE)
      this.getUsersWithFilter({validationInfo: true, showDischargeAdmin: true, needsAdministrativeDischarge: true, sortDirection: 'asc' })
    else if (this.viewState == this.ViewState.ALL_DISCHARGED)
      this.getUsersWithFilter({validationInfo: true, wasDischarged: true, sortDirection: 'asc' })
  }

  changeViewState(param) : void {
    this.viewState = param;
    this.getData();
  }

  onValidationViews(){
    return this.validationViews.indexOf(this.viewState) > -1  // we don't have the includes method in this version of ECMAScript
  }

  onDischargeViews(){
    return this.dischargeViews.indexOf(this.viewState) > -1
  }

  getWhatsAppLink(patient: any): string {
    let msg = '';

    if(this.onValidationViews() && !_.isEmpty(patient.provider.whatsappFirstContactMessage)) {
      msg = patient.provider.whatsappFirstContactMessage;
    }

    if(this.onDischargeViews() && !_.isEmpty(patient.provider.whatsappDischargeMessage)) {
      msg = patient.provider.whatsappDischargeMessage;
    }

    if(!_.isEmpty(msg)) {
      msg = msg.replace("__PATIENT_NAME__", patient.name);
      msg = msg.replace("__PROVIDER_TITLE__", patient.provider.title || patient.provider.name);
      msg = "?text=" + encodeURI(msg);
    }

    return patient.wppLink + msg
  }

  private showErr(error) : void {
    if (error && error._body && error._body.message)
      alert(error._body.message);
    this.getData();
  }

  startValidating(user: any): void {
    if (!confirm("Are you sure you want to start validating this patient?" + user.name)) return;

    this.patientService
    .startValidating(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }

  stopValidating(user: any): void {
    if (!confirm("Are you sure you want to stop validating this patient?" + user.name)) return;

    this.patientService
    .stopValidating(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }

  validate(user: any): void {
    if (!confirm("Are you sure you want to validate this patient?" + user.name)) return;

    this.patientService
    .validatePatient(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }

  invalidate(user: any): void {
    if (!confirm("Are you sure you want to invalidate this patient?" + user.name)) return;

    this.patientService
    .invalidatePatient(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }

  resetFailedValidation(user: any): void {
    if (!confirm("Are you sure you want to invalidate this patient?" + user.name)) return;

    this.patientService
    .resetPatientFailedValidation(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }

  startDischarging(user: any): void {
    if (!confirm("Are you sure you want to start discharging this patient?" + user.name)) return;

    this.patientService
    .startDischarging(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }

  stopDischarging(user: any): void {
    if (!confirm("Are you sure you want to stop discharging this patient?" + user.name)) return;

    this.patientService
    .stopDischarging(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }

  discharge(user: any): void {
    if (!confirm("Are you sure you want to discharge this patient?" + user.name)) return;

    this.patientService
    .administrativeDischargePatient(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }

  resetWasDischarged(user: any): void {
    if (!confirm("Are you sure you want to set this patient as not discharged?" + user.name)) return;

    this.patientService
    .resetPatientWasDischarged(user.id)
    .then((updatedUsers) => {this.getData();})
    .catch(error => {this.showErr(error)});
  }
}



// WEBPACK FOOTER //
// ./src/app/patient-validation/patient-validation.component.ts